<script setup lang="ts">
const DISMISSED_BUILD_ID_KEY = 'gd-pwa-update-dismissed';

// `sessionStorage` lève en navigation privée et sous une politique qui bloque le stockage : le
// rejet ne vaut alors que pour ce montage.
function readDismissed (): string | null {
  try { return sessionStorage.getItem(DISMISSED_BUILD_ID_KEY); } catch { return null; }
}

const { latestBuildId } = useLatestBuild();
const dismissedBuildId = ref(readDismissed());

const visible = computed(() => latestBuildId.value !== null && latestBuildId.value !== dismissedBuildId.value);

function dismiss (): void {
  dismissedBuildId.value = latestBuildId.value;
  try { sessionStorage.setItem(DISMISSED_BUILD_ID_KEY, latestBuildId.value as string); } catch { /* stockage indisponible */ }
}

const { $pwa } = useNuxtApp();

// Activer le worker recharge aussi les autres onglets : voulu, tous finissent sur la même version.
async function update (): Promise<void> {
  if ($pwa?.needRefresh) {
    try {
      await $pwa.updateServiceWorker(true);
      return;
    } catch (error) {
      console.error('[PwaUpdatePrompt]', error);
    }
  }
  window.location.reload();
}
</script>

<template>
  <div
    v-if="visible"
    role="status"
    class="fixed bottom-4 right-4 z-50 flex max-w-[calc(100vw-2rem)] flex-wrap items-center gap-3 rounded-lg bg-primary-600 px-4 py-3 text-white shadow-lg"
  >
    <span>Une nouvelle version est disponible.</span>
    <Button
      label="Mettre à jour"
      severity="contrast"
      size="small"
      @click="update()"
    />
    <Button
      aria-label="Ignorer"
      icon="pi pi-times"
      severity="contrast"
      size="small"
      text
      @click="dismiss()"
    />
  </div>
</template>
